/**
 * @description 險種類別用
 */
export enum InsType {
  All='All',
  Travel= 'I01',
  Car='I02',
  Moto='I03',
  Fire='I04',
  MobileDevice = 'I05',
  Pet='I06',
  ECar='I07',
  Emoto='IEB', //* 微型二輪電動車
}
